module.exports = __webpack_public_path__ + "static/media/Home-T-01.4bd09f53.png";